import { create } from "zustand";
import { SelectedMode } from "../Routes/Home/Components/HomeScreen/constant";

const useHomeStore = create((set) => ({
  originalPrompt: "",
  selectedMode: SelectedMode.CreateImage,
  selectedImage: null,
  previousCreateImagePrompt: "",
  previousPlanYourWeddingPrompt: "",
  previousAIImageEditPrompt: "",
  setSelectedMode: (selectedMode) => set({ selectedMode }),
  setOriginalPrompt: (originalPrompt) => set({ originalPrompt }),
  setSelectedImage: (selectedImage) => set({ selectedImage }),
  setPreviousCreateImagePrompt: (previousCreateImagePrompt) =>
    set({ previousCreateImagePrompt }),
  setPreviousPlanYourWeddingPrompt: (previousPlanYourWeddingPrompt) =>
    set({ previousPlanYourWeddingPrompt }),
  setPreviousAIImageEditPrompt: (previousAIImageEditPrompt) =>
    set({ previousAIImageEditPrompt }),
}));

export default useHomeStore;
